import _taggedTemplateLiteral from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/get";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        display: inline-block;\n      }\n\n      :host([hidden]) {\n        display: none !important;\n      }\n\n      label {\n        display: inline-flex;\n        align-items: baseline;\n        outline: none;\n      }\n\n      [part=\"checkbox\"] {\n        position: relative;\n        display: inline-block;\n        flex: none;\n      }\n\n      input[type=\"checkbox\"] {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        opacity: 0;\n        cursor: inherit;\n        margin: 0;\n      }\n\n      :host([disabled]) {\n        -webkit-tap-highlight-color: transparent;\n      }\n    </style>\n\n    <label>\n      <span part=\"checkbox\">\n        <input type=\"checkbox\" checked=\"{{checked::change}}\" disabled$=\"[[disabled]]\" indeterminate=\"{{indeterminate::change}}\" role=\"presentation\" tabindex=\"-1\">\n      </span>\n\n      <span part=\"label\">\n        <slot></slot>\n      </span>\n    </label>\n"], ["\n    <style>\n      :host {\n        display: inline-block;\n      }\n\n      :host([hidden]) {\n        display: none !important;\n      }\n\n      label {\n        display: inline-flex;\n        align-items: baseline;\n        outline: none;\n      }\n\n      [part=\"checkbox\"] {\n        position: relative;\n        display: inline-block;\n        flex: none;\n      }\n\n      input[type=\"checkbox\"] {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        opacity: 0;\n        cursor: inherit;\n        margin: 0;\n      }\n\n      :host([disabled]) {\n        -webkit-tap-highlight-color: transparent;\n      }\n    </style>\n\n    <label>\n      <span part=\"checkbox\">\n        <input type=\"checkbox\" checked=\"{{checked::change}}\" disabled\\$=\"[[disabled]]\" indeterminate=\"{{indeterminate::change}}\" role=\"presentation\" tabindex=\"-1\">\n      </span>\n\n      <span part=\"label\">\n        <slot></slot>\n      </span>\n    </label>\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { GestureEventListeners } from '@polymer/polymer/lib/mixins/gesture-event-listeners.js';
import { ThemableMixin } from '@vaadin/vaadin-themable-mixin/vaadin-themable-mixin.js';
import { ControlStateMixin } from '@vaadin/vaadin-control-state-mixin/vaadin-control-state-mixin.js';
import { ElementMixin } from '@vaadin/vaadin-element-mixin/vaadin-element-mixin.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
/**
 * `<vaadin-checkbox>` is a Web Component for customized checkboxes.
 *
 * ```html
 * <vaadin-checkbox>
 *   Make my profile visible
 * </vaadin-checkbox>
 * ```
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name         | Description
 * ------------------|----------------
 * `checkbox`        | The wrapper element for the native <input type="checkbox">
 * `label`           | The wrapper element in which the component's children, namely the label, is slotted
 *
 * The following state attributes are available for styling:
 *
 * Attribute    | Description | Part name
 * -------------|-------------|--------------
 * `active`     | Set when the checkbox is pressed down, either with mouse, touch or the keyboard. | `:host`
 * `disabled`   | Set when the checkbox is disabled. | `:host`
 * `focus-ring` | Set when the checkbox is focused using the keyboard. | `:host`
 * `focused`    | Set when the checkbox is focused. | `:host`
 * `indeterminate` | Set when the checkbox is in indeterminate mode. | `:host`
 * `checked` | Set when the checkbox is checked. | `:host`
 * `empty` | Set when there is no label provided. | `label`
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @memberof Vaadin
 * @mixes Vaadin.ElementMixin
 * @mixes Vaadin.ControlStateMixin
 * @mixes Vaadin.ThemableMixin
 * @mixes Polymer.GestureEventListeners
 * @demo demo/index.html
 */

var CheckboxElement =
/*#__PURE__*/
function (_ElementMixin) {
  _inherits(CheckboxElement, _ElementMixin);

  _createClass(CheckboxElement, null, [{
    key: "template",
    get: function get() {
      return html(_templateObject());
    }
  }, {
    key: "is",
    get: function get() {
      return 'vaadin-checkbox';
    }
  }, {
    key: "version",
    get: function get() {
      return '2.2.12';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        /**
         * True if the checkbox is checked.
         */
        checked: {
          type: Boolean,
          value: false,
          notify: true,
          observer: '_checkedChanged',
          reflectToAttribute: true
        },

        /**
         * Indeterminate state of the checkbox when it's neither checked nor unchecked, but undetermined.
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#Indeterminate_state_checkboxes
         */
        indeterminate: {
          type: Boolean,
          notify: true,
          observer: '_indeterminateChanged',
          reflectToAttribute: true,
          value: false
        },

        /**
         * The value given to the data submitted with the checkbox's name to the server when the control is inside a form.
         */
        value: {
          type: String,
          value: 'on'
        },
        _nativeCheckbox: {
          type: Object
        }
      };
    }
  }]);

  function CheckboxElement() {
    var _this;

    _classCallCheck(this, CheckboxElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckboxElement).call(this));
    /**
     * @type {string}
     * Name of the element.
     */

    _this.name;
    return _this;
  }

  _createClass(CheckboxElement, [{
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(CheckboxElement.prototype), "ready", this).call(this);

      this.setAttribute('role', 'checkbox');
      this._nativeCheckbox = this.shadowRoot.querySelector('input[type="checkbox"]');
      this.addEventListener('click', this._handleClick.bind(this));

      this._addActiveListeners();

      var attrName = this.getAttribute('name');

      if (attrName) {
        this.name = attrName;
      }

      this.shadowRoot.querySelector('[part~="label"]').querySelector('slot').addEventListener('slotchange', this._updateLabelAttribute.bind(this));

      this._updateLabelAttribute();
    }
  }, {
    key: "_updateLabelAttribute",
    value: function _updateLabelAttribute() {
      var label = this.shadowRoot.querySelector('[part~="label"]');
      var assignedNodes = label.firstElementChild.assignedNodes();

      if (this._isAssignedNodesEmpty(assignedNodes)) {
        label.setAttribute('empty', '');
      } else {
        label.removeAttribute('empty');
      }
    }
  }, {
    key: "_isAssignedNodesEmpty",
    value: function _isAssignedNodesEmpty(nodes) {
      // The assigned nodes considered to be empty if there is no slotted content or only one empty text node
      return nodes.length === 0 || nodes.length == 1 && nodes[0].nodeType == Node.TEXT_NODE && nodes[0].textContent.trim() === '';
    }
  }, {
    key: "_checkedChanged",
    value: function _checkedChanged(checked) {
      if (this.indeterminate) {
        this.setAttribute('aria-checked', 'mixed');
      } else {
        this.setAttribute('aria-checked', checked);
      }
    }
  }, {
    key: "_indeterminateChanged",
    value: function _indeterminateChanged(indeterminate) {
      if (indeterminate) {
        this.setAttribute('aria-checked', 'mixed');
      } else {
        this.setAttribute('aria-checked', this.checked);
      }
    }
  }, {
    key: "_addActiveListeners",
    value: function _addActiveListeners() {
      var _this2 = this;

      // DOWN
      this._addEventListenerToNode(this, 'down', function (e) {
        if (_this2.__interactionsAllowed(e)) {
          _this2.setAttribute('active', '');
        }
      }); // UP


      this._addEventListenerToNode(this, 'up', function () {
        return _this2.removeAttribute('active');
      }); // KEYDOWN


      this.addEventListener('keydown', function (e) {
        if (_this2.__interactionsAllowed(e) && e.keyCode === 32) {
          e.preventDefault();

          _this2.setAttribute('active', '');
        }
      }); // KEYUP

      this.addEventListener('keyup', function (e) {
        if (_this2.__interactionsAllowed(e) && e.keyCode === 32) {
          e.preventDefault();

          _this2._toggleChecked();

          _this2.removeAttribute('active');

          if (_this2.indeterminate) {
            _this2.indeterminate = false;
          }
        }
      });
    }
    /** @protected */

  }, {
    key: "__interactionsAllowed",

    /**
     * True if users' interactions (mouse or keyboard)
     * should toggle the checkbox
     */
    value: function __interactionsAllowed(e) {
      if (this.disabled) {
        return false;
      } // https://github.com/vaadin/vaadin-checkbox/issues/63


      if (e.target.localName === 'a') {
        return false;
      }

      return true;
    }
  }, {
    key: "_handleClick",
    value: function _handleClick(e) {
      if (this.__interactionsAllowed(e)) {
        if (!this.indeterminate) {
          if (e.composedPath()[0] !== this._nativeCheckbox) {
            e.preventDefault();

            this._toggleChecked();
          }
        } else {
          /*
           * Required for IE 11 and Edge.
           * See issue here: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7344418/
           */
          this.indeterminate = false;
          e.preventDefault();

          this._toggleChecked();
        }
      }
    }
  }, {
    key: "_toggleChecked",
    value: function _toggleChecked() {
      this.checked = !this.checked;
      this.dispatchEvent(new CustomEvent('change', {
        composed: false,
        bubbles: true
      }));
    }
    /**
     * Fired when the user commits a value change.
     *
     * @event change
     */

  }, {
    key: "name",
    get: function get() {
      return this.checked ? this._storedName : '';
    },
    set: function set(name) {
      this._storedName = name;
    }
  }, {
    key: "focusElement",
    get: function get() {
      return this.shadowRoot.querySelector('input');
    }
  }]);

  return CheckboxElement;
}(ElementMixin(ControlStateMixin(ThemableMixin(GestureEventListeners(PolymerElement)))));

customElements.define(CheckboxElement.is, CheckboxElement);
export { CheckboxElement };